import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IndicadorEnum } from 'src/app/global/enums/indicador.enum';
import { EstadoDocumento } from 'src/app/global/interfaces/estado-documento';
import { GeneralResponseGeneric } from 'src/app/global/interfaces/general-response-generic';
import { DocumentService } from 'src/app/global/services/document.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class DocumentProvider extends DocumentService {

  private api = environment.api;
  private uri = this.api.host + this.api.path;
  private endpoints = this.api.endpoints.checkout.documents;
  constructor(private http: HttpClient) {
    super();
  }

  requiredDocuments(): Observable<any[]> {
    const endpoint = this.uri + this.endpoints.requiredDocument;
    return this.http.get<any[]>(endpoint);
  }
  documentStatus(): Observable<EstadoDocumento[]> {
    const endpoint = this.uri + this.endpoints.documentStatus;
    return this.http.get<EstadoDocumento[]>(endpoint);
  }

  saveDocument(documentsRequest: any): Observable<GeneralResponseGeneric<unknown, IndicadorEnum>> {
    const endpoint = this.uri + this.endpoints.saveDocument;
    return this.http.post<GeneralResponseGeneric<unknown, IndicadorEnum>>(endpoint, documentsRequest);
  }

  deleteDocument(): Observable<GeneralResponseGeneric<unknown, IndicadorEnum>> {
    const endpoint = this.uri + this.endpoints.deleteDocument;
    return this.http.delete<GeneralResponseGeneric<unknown, IndicadorEnum>>(endpoint);
  }


}
